// ============================================================================
// OMS sales-order detail — full-width sub-screen (/oms/:salesOrderId).
// Back button returns to the list.
// ============================================================================
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button } from "antd";
import React from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import SalesOrderDetailView from "./components/sales_order_detail";
import SectionBoundary from "./components/section_boundary";
import styles from "./index.module.scss";

const OmsSalesOrderDetail: React.FC = () => {
  const navigate = useNavigate();
  const { salesOrderId } = useParams<{ salesOrderId: string }>();
  const [searchParams] = useSearchParams();
  const id = salesOrderId ? Number(salesOrderId) : undefined;
  // Deep link from a board (/oms/po by allocation id, Operations by PO number): open on the
  // allotment that was clicked instead of making the operator find it among the order's other legs.
  const allocationParam = Number(searchParams.get("allocation"));
  const highlightAllocationId = Number.isFinite(allocationParam) && allocationParam > 0
    ? allocationParam
    : undefined;
  const highlightPoNumber = searchParams.get("po") || undefined;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Button
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate("/oms")}
          style={{ marginRight: 8 }}
        >
          Back to orders
        </Button>
      </div>
      {/* Last line of defence: whatever the sections themselves don't contain, this does — the
          back button and app shell stay usable instead of the route rendering a blank screen. */}
      <SectionBoundary name="This order">
        <SalesOrderDetailView
          salesOrderId={id}
          highlightAllocationId={highlightAllocationId}
          highlightPoNumber={highlightPoNumber}
        />
      </SectionBoundary>
    </div>
  );
};

export default OmsSalesOrderDetail;
